import * as Yup from 'yup';

/**
 * Catálogo fixo do "Tipo de Ocorrência" do RG 26/POP 05 (COOASGO).
 * Os values (`id`) são o contrato com o backend — não alterar sem
 * atualizar docs/CONTROLE_QUALIDADE_MVP.md.
 */
export const OCCURRENCE_TYPE_OPTIONS = [
  { id: 'internal_audit', value: 'internal_audit', label: 'Auditoria Interna' },
  {
    id: 'internal_nc_process',
    value: 'internal_nc_process',
    label: 'NC Interna / Processo',
  },
  {
    id: 'management_review',
    value: 'management_review',
    label: 'Análise Crítica da Administração',
  },
  {
    id: 'satisfaction_survey',
    value: 'satisfaction_survey',
    label: 'Pesquisa de Satisfação',
  },
  { id: 'supplier_nc', value: 'supplier_nc', label: 'NC de Fornecedor' },
  {
    id: 'complaint_return',
    value: 'complaint_return',
    label: 'Reclamação / Devolução',
  },
  { id: 'employee_nc', value: 'employee_nc', label: 'NC / Colaborador' },
];

export const OCCURRENCE_TYPE_LABELS: Record<string, string> =
  OCCURRENCE_TYPE_OPTIONS.reduce(
    (acc, option) => ({ ...acc, [option.value]: option.label }),
    {},
  );

export type FactoryUnit = 'bovine' | 'swine';

export const FACTORY_OPTIONS: { value: FactoryUnit; label: string }[] = [
  { value: 'bovine', label: 'Fábrica Bovina' },
  { value: 'swine', label: 'Fábrica Suína' },
];

export const FACTORY_LABELS: Record<FactoryUnit, string> = {
  bovine: 'Fábrica Bovina',
  swine: 'Fábrica Suína',
};

// Onde o rótulo "Fábrica" já aparece (coluna da lista, cartão do celular).
export const FACTORY_SHORT_LABELS: Record<FactoryUnit, string> = {
  bovine: 'Bovina',
  swine: 'Suína',
};

export type NonConformityStatus = 'open' | 'in_progress' | 'closed';

export const STATUS_LABELS: Record<NonConformityStatus, string> = {
  open: 'Aberto',
  in_progress: 'Em Andamento',
  closed: 'Concluído',
};

export const STATUS_COLOR_SCHEMES: Record<NonConformityStatus, string> = {
  open: 'orange',
  in_progress: 'blue',
  closed: 'green',
};

export const ACTION_KIND_LABELS = {
  corrective: 'Ação Corretiva',
  preventive: 'Ação Preventiva',
};

export const EVIDENCE_ALLOWED_TYPES = [
  'image/jpeg',
  'image/jpg',
  'image/png',
  'application/pdf',
];

export const EVIDENCE_MAX_SIZE_BYTES = 5 * 1024 * 1024;

export const nonConformitySchema = Yup.object().shape({
  title: Yup.string().trim().required('Informe o título da não conformidade'),
  opened_at: Yup.string().required('Informe a data de abertura da NC'),
  occurrence_types: Yup.array()
    .of(Yup.string())
    .min(1, 'Selecione ao menos um tipo de ocorrência'),
  factory_unit: Yup.string().required('Selecione a fábrica'),
  supplier_or_producer: Yup.string().nullable(),
  description: Yup.string()
    .trim()
    .required('Descreva a não conformidade e sua causa'),
});

export interface ActionDraft {
  description: string;
  responsible: string;
  due_date: string;
}

export const actionDraftSchema = Yup.object().shape({
  description: Yup.string().trim().required('Informe a ação'),
  responsible: Yup.string().trim().required('Informe o responsável'),
  due_date: Yup.string().required('Informe o prazo'),
});
